import { IonButton, IonIcon, IonItem, IonLabel, IonSpinner, IonText } from '@ionic/react';
import { refresh } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { syncTimer } from '../../../common/interval';
import { useDataSync } from '../../../providers/DataSyncProvider';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setMediaSettingsHasSyncStoreAsync, setMediaSettingsSyncLoadingState } from '../../../store/mediaSettingsSyncSlice';
import { IMediaSettingsSyncStatus } from '../../../models/dms/systemConfiguration.model';

interface IComponentProps {
  title: string;
}

let mediaSettingsTime: { timestamp: number; sync?: IMediaSettingsSyncStatus } = {
  timestamp: 0,
  sync: undefined,
};

const MediaSettingsSyncItem: React.FC<IComponentProps> = ({ title }) => {
  const { enableOfflineMode } = useAppSelector((state) => state.settings);
  const {
    state: { mediaSettingsSyncTimer },
  } = useDataSync();

  const dispatch = useAppDispatch();

  const [mediaSettingsTimestamp, setMediaSettingsTimestamp] = useState(0);
  const { mediaSettingsSync, mediaSettingsSyncLoading } = useAppSelector((state) => state.mediaSettingsSync);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const now = new Date().getTime();

        // Repair orders
        if (mediaSettingsTime.sync) {
          if (mediaSettingsTime.sync.timestamp <= 0) {
            mediaSettingsTime.timestamp = -1;
          } else {
            const timeDiff = now - mediaSettingsTime.sync.timestamp;
            mediaSettingsTime.timestamp = Math.floor(timeDiff / 60000);
            setMediaSettingsTimestamp(mediaSettingsTime.timestamp);
          }
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    mediaSettingsTime.sync = mediaSettingsSync;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaSettingsSync]);

  const handleRefreshButtonClick = () => {
    dispatch(setMediaSettingsSyncLoadingState(true));
    dispatch(setMediaSettingsHasSyncStoreAsync(false));
    mediaSettingsSyncTimer?.fire();
  };

  return (
    <IonItem>
      <IonLabel text-wrap>
        <IonText>
          <IonLabel>{title}</IonLabel>
        </IonText>
        {(() => {
          switch (mediaSettingsSyncLoading) {
            case false:
              return (
                <IonText color="medium">
                  Last sync - <span>{mediaSettingsTimestamp} minutes</span>
                </IonText>
              );
            case true:
              return <IonText>Last sync - synchronising...</IonText>;
          }
        })()}
      </IonLabel>
      {enableOfflineMode && (
        <IonButton slot="end" color="primary" disabled={mediaSettingsSyncLoading} onClick={() => handleRefreshButtonClick()}>
          {(() => {
            switch (mediaSettingsSyncLoading) {
              case false:
                return <IonIcon icon={refresh} color="secondary" />;
              case true:
                return <IonSpinner name="lines-small" color="secondary"></IonSpinner>;
            }
          })()}
        </IonButton>
      )}
    </IonItem>
  );
};

export default MediaSettingsSyncItem;
